export default {"src":"/_next/static/media/about7.e4d61548.svg","height":431,"width":133};